import { render, staticRenderFns } from "./CourseCardSlick.vue?vue&type=template&id=38ca9b24"
import script from "./CourseCardSlick.vue?vue&type=script&lang=js"
export * from "./CourseCardSlick.vue?vue&type=script&lang=js"
import style0 from "./CourseCardSlick.vue?vue&type=style&index=0&id=38ca9b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports